import { withStyles } from '@material-ui/core';
import { compose } from 'ramda';
import { number, object, string } from 'yup';

import styles from '@/features/authPages/styles';
import withAsyncFormik from '@/hocs/withAsyncFormik';

import AddBonusesForm from './component';

const errorsMapping = {};
const formikOptions = {
  // eslint-disable-next-line camelcase
  mapPropsToValues: ({ level, comment, commissar_id }) => ({
    level,
    comment,
    commissar_id,
  }),

  validationSchema: object().shape({
    level: string().required(),
    comment: string()
      .min(10, 'Комментарий должен быть не менее 10 символов')
      .max(200, 'Комментарий должен быть не более 200 символов')
      .required(),
    commissar_id: number().required(),
  }),
  // eslint-disable-next-line camelcase
  handleSubmit({ level, comment, commissar_id }, { props, setSubmitting }) {
    props.onSubmit({ level, comment, commissar_id });
    setSubmitting(false);
  },
};

const asyncOptions = { runnerMethod: 'onSubmit' };

export default compose(
  withAsyncFormik({ errorsMapping, formikOptions, asyncOptions }),
  withStyles(styles),
)(AddBonusesForm);
